import R from 'ramda'
import navList from './navigate'
import access from './access'
import thirdParty from './thirdParty'

import pageReducerList from './page'

// if ever you move to immutable.js, check out https://medium.com/@drboolean/lenses-with-immutable-js-9bda85674780
// some interesting things to find there regarding composable lenses

const concatAll = R.reduce(R.concat, [])

const unknownAction = ({state, action}) => {
  // console.error('unkown action', action)
  return state
}

const catchAll = [
  [R.T, unknownAction]
]

const reducer = (state = {}, action) => R.cond(
  concatAll([
    access,
    thirdParty,
    pageReducerList,
    navList,
    catchAll
  ])
)({state, action})

export default reducer



// WEBPACK FOOTER //
// ./webAdmin/reducers/index.js